import React, { useEffect, useState } from 'react';
import styles from './specificationsTab.module.css';
import { Download, Filter } from '../../../../Svg';
import { Menu, MenuItem, Button } from '@mui/material';
import { styled } from '@mui/material/styles';
import CatPagination from '../../../../Website/utils/Pagination';
import AllVenEnquiresTable from './AllVenEnquiresTable';
import { useDispatch, useSelector } from 'react-redux';
import { getRecievedEnquirydetailsThunk, setRecievePage } from '../../../../Website/redux/recievedEnquiriesSlice';

const ActionButton = styled(Button)(({ theme }) => ({
  textTransform: 'none',
  fontSize: '014px',
  color: '#667085',
  backgroundColor: '#F0F1F3',
  fontSize: '14px',
  borderRadius: "4px",
  height: "40px",
  fontFamily: `'Public Sans', sans-serif`,
  '&:hover': {
    backgroundColor: theme.palette.grey[200],
  },
}));

const AllVenEnquiresTab = ({ attributes, additionalResources, setStatus, }) => {
  const [activeTab, setActiveTab] = useState('BOM');
  const tabs = ['BOM', 'Wizard', 'ExcessInventory'];
  const [anchorEl, setAnchorEl] = useState(null);
  const [limit, setLimit] = useState(25)
  const open = Boolean(anchorEl);
  const { enquiries, page, refresh } = useSelector(state => state.recievedEnquiries)
  const data = enquiries?.data
  const totalPages = enquiries?.totalPages
  const totalItems = enquiries?.totalItems
  const itemsPerPage = enquiries?.limit
  const dispatch = useDispatch()

  // calculate start & end of items -------------------
  const start = (page - 1) * limit + 1;
  const end =
    totalPages === page
      ? totalItems
      : (page - 1) * limit + limit;

  console.log(enquiries);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = (status) => {
    if (status) {
      setStatus(status)
    }
    setAnchorEl(null);
  };


  useEffect(() => {
    if (activeTab === "BOM") {
      dispatch(getRecievedEnquirydetailsThunk(`?enquiryType=BOM`))
    }
  }, [refresh])


  return (
    <>
      <div className={styles.profilebodyContainer}>
        <div className={styles.profileheader}>
          <h2>All Enquiry</h2>

          <div className={styles.displayFlex} >
            <div>
              <ActionButton
                onClick={handleClick}
                sx={{
                  color: '#667085',
                  border: '1px solid #E0E2E7',
                  background: '#fff',
                  borderRadius: '8px',
                }}
              >
                <Filter /> Filters
              </ActionButton>
              <Menu
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
                MenuListProps={{
                  'aria-labelledby': 'status-button',
                }}
              >
                <MenuItem onClick={() => handleClose('ACTIVE')}
                  sx={{
                    borderBottom: '1px solid #E6E1E5',
                    fontSize: '14px',
                    color: '#667085',
                  }}>Active</MenuItem>
                <MenuItem onClick={() => handleClose('INACTIVE')}
                  sx={{
                    fontSize: '14px',
                    color: '#667085',
                  }}>Inactive</MenuItem>
              </Menu>
            </div>
            <button className={styles.submitBtn}><Download /> Download</button>
          </div>

        </div>
        <div className={styles.speccontainer}>
          <div className={styles.spectabs}>
            {tabs.map((tab) => (
              <button
                key={tab}
                className={`${styles.spectabButton} ${activeTab === tab ? styles.active : ''}`}
                onClick={() => setActiveTab(tab)}
              >
                {tab === 'BOM' && 'BOM'}
                {tab === 'Wizard' && 'Wizard'}
                {tab === 'ExcessInventory' && 'ExcessInventory'}
              </button>
            ))}
          </div>

          {data?.length > 0 ?

            < AllVenEnquiresTable data={data} />
            :
            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center',padding:20 }}>
              No Enquiries available
            </div>
          }

        </div>
        {data?.length > 0 &&
          <CatPagination
            totalItems={totalItems}
            itemsPerPage={itemsPerPage}
            start={start}
            end={end}
            page={page}
            setPage={setRecievePage}
          />
        }
      </div>
    </>
  );
};

export default AllVenEnquiresTab;
